<!-- Template con estilos del dashboard -->
<div class="app-page">
  <div class="app-page-content">
    <section class="app-card">
      
      <!-- Header -->
      <header class="mb-6 flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
        <div class="flex flex-col gap-1">
          <h1 class="section-title">Reportes</h1>
          <p class="section-subtitle">
            Generación y visualización de reportes
          </p>
        </div>
      </header>

      <!-- Contenido vacío -->
      <div class="flex flex-col items-center justify-center py-16">
        <i class="pi pi-file text-6xl text-muted mb-4"></i>
        <h2 class="text-xl font-semibold text-muted mb-2">Funcionalidad no implementada</h2>
        <p class="text-muted text-center max-w-md">
          Esta funcionalidad estará disponible en una futura actualización.
        </p>
      </div>
    </section>
  </div>
</div>

